import { ItineraryVersion } from 'core/graphql/types';

export interface DeliveryTimesProps {
  itineraryVersion: ItineraryVersion;
}

const DeliveryTimes = ({ itineraryVersion }: DeliveryTimesProps) => (
  <>
    <div className="mt-2">Delivery Times</div>
    <div>
      <div className="mt-2 w-full rounded-sm bg-muted-white p-1 text-center dark:bg-design-secondary-black">
        {`Small/Normal Delivery - ${
          itineraryVersion?.smallAndNormalAwbDeliveryTime ?? 'NA'
        }`}
      </div>
      <div className="mt-2 w-full rounded-sm bg-muted-white p-1 text-center dark:bg-design-secondary-black">
        {`Large Delivery - ${itineraryVersion?.largeAwbDeliveryTime ?? 'NA'}`}
      </div>
      <div className="mt-2 w-full rounded-sm bg-muted-white p-1 text-center dark:bg-design-secondary-black">
        {`Approximate Location Additional Time - ${
          itineraryVersion?.approximateLocationAdditionalTime ?? 'NA'
        }`}
      </div>
      <div className="mt-2 w-full rounded-sm bg-muted-white p-1 text-center dark:bg-design-secondary-black">
        {`OOH Additional Time - ${
          itineraryVersion?.oohAdditionalTime ?? 'NA'
        }`}
      </div>
      <div className="mt-2 w-full rounded-sm bg-muted-white p-1 text-center dark:bg-design-secondary-black">
        {`Parking Time - ${itineraryVersion?.parkingTime ?? 'NA'}`}
      </div>
    </div>
  </>
);

export default DeliveryTimes;
